import { wrapRequest, meWrapRequest } from "../nav";
import { wrapGqlRequest } from "../graphqlEndPointCommonSetting/wrapGqlRequest";
const vueAppMagenotApiUrl = import.meta.env.VITE_MAGENTO_API_URL;

export const doSetPaymentMethodOnCart = (
  userQuoteId,
  paymentMethod,
  clientSecret,
) => {
  const additionalDataGql = Object.entries(paymentMethod.additional_data)
    .map(([key, value]) => `{ key: "${key}", value: "${value}" }`)
    .join(", ");
  const setPaymentMethodOnCartMutation = `mutation {
    setPaymentMethodOnCart(input: {
        cart_id: "${userQuoteId}"
        payment_method: {
            code: "${paymentMethod.method}"
          additional_data: [
          ${additionalDataGql}
        ]
        }
    }) {
      cart {
        selected_payment_method {
          code
          title
          oope_payment_method_config {
          backend_integration_url
          custom_config {
            ... on CustomConfigKeyValue {
                key
                value
            }
          }
        }
        }
      }
    }
  }
  `;

  return wrapGqlRequest(
    setPaymentMethodOnCartMutation,
    {},
    "setPaymentMethodOnCart",
  );
};

export const doPlaceOrderMutation = async (userQuoteId) => {
  const placeOrderMutation = `
      
 mutation {
  placeOrder(input: { cart_id: "${userQuoteId}" }) {
    errors {
      code
      message
    }
    orderV2 {
      id
      number
      token
      email
      status
      order_date
      order_status_change_date
      is_virtual
      available_actions
      carrier
      shipping_method

      customer_info {
        firstname
        lastname
        middlename
      }

      payment_methods {
        name
        type
      }

      shipping_address {
        firstname
        lastname
        city
        company
        country_code
        region
        region_id
        postcode
        street
        telephone
      }

      billing_address {
        firstname
        lastname
        city
        company
        country_code
        region
        region_id
        postcode
        street
        telephone
      }

      shipments {
        id
        number
        tracking {
          title
          number
          carrier
        }
      }

      items {
        id
        status
        product_name
        quantity_ordered
        quantity_shipped
        quantity_invoiced
        product_sku

        product_sale_price {
          value
          currency
        }

        selected_options {
          label
          value
        }

        product {
          custom_attributesV2 {
            items {
              code
              ... on AttributeValue {
                value
              }
              ... on AttributeSelectedOptions {
                selected_options {
                  value
                  label
                }
              }
            }
          }
        }
      }

      applied_coupons {
        code
      }

      total {
        subtotal_excl_tax {
          value
          currency
        }
        subtotal_incl_tax {
          value
          currency
        }
        grand_total {
          value
          currency
        }
        total_tax {
          value
          currency
        }
        total_shipping {
          value
          currency
        }
        discounts {
          label
          amount {
            value
            currency
          }
        }
      }
    }
  }
}
  `;
  return wrapGqlRequest(placeOrderMutation, {}, "placeOrder");
};
